import site from '../../content/site.json';
import seo from '../../content/seo.json';
import home from '../../content/home.json';
import legal from '../../content/legal.json';
import university from '../../content/university.json';
import course from '../../content/course.json';
import amity from '../../content/universities/amity.json';
import lpu from '../../content/universities/lpu.json';
import dyPatil from '../../content/universities/dy-patil.json';
import parul from '../../content/universities/parul.json';
import vgu from '../../content/universities/vgu.json';

const UNIVERSITY_PACKS = [amity, lpu, dyPatil, parul, vgu];

const SLUG_TO_PACK = new Map();
for (const pack of UNIVERSITY_PACKS) {
  for (const key of pack.slugKeys || []) {
    SLUG_TO_PACK.set(String(key).toLowerCase(), pack);
  }
}

export function getSite() {
  return site;
}

export function getSeo() {
  return seo;
}

export function getHome() {
  return home;
}

export function getInfoPages() {
  return legal.pages || [];
}

export function getLegalPage(pageId) {
  if (!pageId || !legal[pageId]) return null;
  const nav = (legal.pages || []).find((item) => item.id === pageId) || {};
  return { ...legal[pageId], ...nav };
}

export function isInfoPath(pathname) {
  const path = String(pathname || '');
  return (legal.pages || []).some((item) => item.path === path);
}

export function getUniversityCopy() {
  return university;
}

export function getCourseCopy() {
  return course;
}

export function getLeadIntentCopy(intent = 'counsel') {
  if (intent !== 'counsel' && site.leadIntents?.[intent]) {
    return site.leadIntents[intent];
  }
  return {
    success: 'Thanks! A counsellor will contact you shortly.',
    consent: 'I agree to be contacted about programs via phone, email, or WhatsApp.'
  };
}

export function programInterestLabel(courseName, universityName) {
  return [courseName, universityName].filter(Boolean).join(' — ');
}

export function fillTemplate(template, vars = {}) {
  if (!template) return '';
  return template.replace(/\{\{(\w+)\}\}/g, (_, key) => {
    const value = vars[key];
    return value == null ? '' : String(value);
  });
}

function fuzzyUniversityPack(slug) {
  const s = String(slug || '').toLowerCase();
  if (s.includes('amity')) return amity;
  if (s.includes('lpu') || s.includes('lovely')) return lpu;
  if (s.includes('dy-patil') || s.includes('dypatil') || s.includes('dpu')) return dyPatil;
  if (s.includes('parul')) return parul;
  if (s.includes('vgu') || s.includes('vivekanand')) return vgu;
  return null;
}

export function getUniversityPack(slug) {
  if (!slug) return null;
  const exact = SLUG_TO_PACK.get(String(slug).toLowerCase());
  if (exact) return exact;
  return fuzzyUniversityPack(slug);
}

export function resolveUniversitySeo(slug, universityName) {
  const pack = getUniversityPack(slug);
  const fallback = seo.universityFallback;
  const brand = site.brand;
  if (pack) {
    return {
      title: pack.title,
      description: pack.description,
      h1: pack.h1,
      intro: pack.intro,
      faqs: pack.faqs || []
    };
  }
  return {
    title: fillTemplate(fallback.title, { university: universityName || 'University', brand }),
    description: fillTemplate(fallback.description, {
      university: universityName || 'University',
      brand
    }),
    h1: universityName || 'University',
    intro: null,
    faqs: []
  };
}

export function resolveCourseSeo(courseName, universityName) {
  const fallback = seo.courseFallback;
  const brand = site.brand;
  return {
    title: fillTemplate(fallback.title, {
      course: courseName || 'Course',
      university: universityName || 'University',
      brand
    }),
    description: fillTemplate(fallback.description, {
      course: courseName || 'Course',
      university: universityName || 'University',
      brand
    })
  };
}
